import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import work3image2 from '../../documents/work3image2.png'
import work3image3 from '../../documents/work3image3.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Work3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            internship1Key: ['Project Cost – $ 18.76M','	3.2+ tonnage of reinforcement checking as per drawing','	Supervised stacking and erection of 500+ precast elements ',
           'Assisted the field staff and superintendents with day-to-day tasks','700+ quantity take-off from drawing','	Codes studied – IS 383, IS 516, IS 1199, IS 9103 and IS 456',
           '	250+ cube tested & report generated','Supervised 550+ m3 concrete casting & finishing ','	Managed 100+ labor for rebar'
                ],                    
            internship1Value: ['Exposure to precast technology- Incorporation of ethics and work culture-Attention to detail'],     
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>B.G.Shirke Construction Technologies Ltd., India</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>(January-May2021)</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiText>
                           <b>Position:</b> Project Coordinator Apprentice<EuiSpacer size='m' /><b>Project: </b>Maharashtra Housing & Area Development Authority- LIG (lower income group) and MIG (middle income group)
                                scheme under MaharashtraGovernment<EuiSpacer size='m' />
                           <b>Key Responsibilities</b>
                        <StyledText><ul className="skills-list">
                        {this.state.internship1Key && this.state.internship1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.internship1Value && this.state.internship1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'><EuiImage size='l' src={work3image2} /><br/>
                Site Office Work</EuiText></EuiFlexItem>
                <EuiFlexItem><EuiText textAlign='center'><EuiImage size='l' src={work3image3} /><br/>
                Concrete Testing as per IS 516</EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Work3 }